export const currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
